import {atom} from "recoil";

export interface AuthState {
  token: string | null;
  refreshToken: string | null;
  tokenParsed: object | null;
}

export const authState = atom<AuthState>({
  key: "authState",
  default: {
    token: null,
    refreshToken: null,
    tokenParsed: null,
  },
});
